import * as React from 'react';
import { classNames } from '@progress/kendo-react-common';
export var ColumnMenuItem = function (props) {
    return (React.createElement("div", { onClick: props.onClick, className: classNames('k-columnmenu-item', { 'k-state-selected': props.selected }, { 'k-state-disabled': props.disabled }) },
        props.iconClass && React.createElement("span", { className: "k-icon " + props.iconClass }),
        props.title));
};
//# sourceMappingURL=ColumnMenuItem.js.map